import { Subscription } from '@raysee/schema';
import firebase from 'firebase';

export class SubscriptionRepository {
  findByUserId = async (userId: string): Promise<Subscription[]> => {
    try {
      const docSnap = await firebase
        .firestore()
        .collection('subscriptions')
        .where('userId', '==', userId)
        .get();
      return docSnap.docs.map((doc) => doc.data() as Subscription);
    } catch (e) {
      throw new Error(e);
    }
  };
}
